import { AnnouncementAppView } from '@/views';

const redirectIfSignedIn = (route, query) => function redirect() {
  if (this.$store != null && this.$store.getters['session/isSignedIn']) {
    this.$router.push({ path: route, query });
  }
};

const routes = {
  publicPaths: [
    {
      path: 'announcementapp',
      name: 'AnnouncementApp',
      component: AnnouncementAppView,
      props: () => ({
        onMounted: redirectIfSignedIn('/'),
      }),
    },
  ],
};

export default routes;
